import { createApi, endpoint } from '@/shared/lib/http/endpoint';

import type { ClusterInfo } from './cluster-state';

// Backend wire types for /csp/list and /cluster/region-list aren't generated
// in cloud-typings yet (PbCsp namespace covers enums + Csp shape but not the
// list-RPC envelope). Local minimal app-shape types here; promote into
// cloud-typings if other modules need them.
export interface CspSummary {
  bizId?: string;
  csp?: string;
  // Present on the AWS entry; consumed by the account audit-log-export IAM
  // trust-policy guidance (the platform's trusted AWS account id).
  trusted_account_id?: string;
  accountId?: string;
}

// One-shot IAM External ID for a cross-account role trust policy (audit-log
// export). Fetched fresh each time the create dialog opens.
export interface ExternalIdResponse {
  eid?: string;
}

export interface RegionSummary {
  cspId?: string;
  region?: string;
  // Region record id. The alert policy form posts the region NAME but keys its
  // select on bizId, so both are read.
  bizId?: string;
  // Localized region labels; the first entry is the display name.
  details?: { name?: string }[];
}

export interface CspListResponse {
  list?: CspSummary[];
}

export interface RegionListRequest {
  filters?: { available?: boolean }[];
  // Server-side ordering. The alert policy form defaults to the FIRST region,
  // so it asks for a region-name sort; the sidebar doesn't care about order.
  common?: { orders?: { col: string; desc: boolean }[] };
}

export interface RegionListResponse {
  list?: RegionSummary[];
}

// /cluster/cluster-list returns the full cluster inventory. Support's ticket
// dialog reads only centralCluster {bizId, name} + the fields calClusterState
// derives from — ClusterInfo captures that slice.
export interface ClusterListResponse {
  list?: ClusterInfo[];
  total?: number;
}

export const clusterMetaApi = createApi({
  '/csp/list': endpoint<void, CspListResponse>('POST'),
  '/cluster/region-list': endpoint<RegionListRequest, RegionListResponse>('POST'),
  '/cluster/cluster-list': endpoint<void, ClusterListResponse>('POST'),
  '/cluster/get-external-id': endpoint<void, ExternalIdResponse>('POST'),
});
